import get from "lodash/get"
import React, { useContext, useState } from "react"
import { useRegistrationsQuery } from "../../api/generated"
import { flattenEdges, usePaginator } from "../../utils/apollo"
import {
  ENROLLMENT_CONTROL_FILTER_BY_ALL_ROLES,
  ENROLLMENT_CONTROL_SORT_BY_DATE_ACTIVE,
  getFilterVariables,
  getSortVariables
} from "./utils"

export const RegistrationListContext = React.createContext()

export const useRegistrationListContext = () =>
  useContext(RegistrationListContext)

const RegistrationListContainer = ({
  children,
  cohortId,
  filter: filterProp,
  sort: sortProp
}) => {
  const [filter, setFilter] = useState(
    filterProp || ENROLLMENT_CONTROL_FILTER_BY_ALL_ROLES
  )
  const [sort, setSort] = useState(
    sortProp || ENROLLMENT_CONTROL_SORT_BY_DATE_ACTIVE
  )

  const { roleFilter } = getFilterVariables(filter)
  const { orderBy } = getSortVariables(sort)
  const result = useRegistrationsQuery({
    variables: {
      groupId: cohortId,
      roleFilter,
      orderBy
    }
  })

  const { data, error, loading, refetch } = result

  const { loadMore, hasMore, loadingMore } = usePaginator({
    data: result, // hacky
    path: "group.registrations"
  })
  const total = get(data, "group.registrations.total", 0)
  const registrations = flattenEdges(get(data, "group.registrations"))

  return (
    <RegistrationListContext.Provider
      value={{
        filter,
        sort,
        onFilter: setFilter,
        onSort: setSort,
        context: {
          cohortId
        },
        roleFilter,
        orderBy,
        registrations,
        loading,
        hasMore,
        loadingMore,
        loadMore
      }}
    >
      {children}
    </RegistrationListContext.Provider>
  )
}

RegistrationListContainer.displayName = "RegistrationListContainer"

export default RegistrationListContainer
